// Page (DESIGN §2): the root of every view — header (title + muted meta + actions) + content + optional right panel.
//   <Page title="Overview" actions={<CompactDropdown …/>} aside={<><RightPanelSection title="Today">…</RightPanelSection></>}>
//     …content…
//   </Page>
// title: string | node (h1). meta: muted text after the title ("Batch 03"). subtitle: one muted line under it.
// actions: right side of the header (one primary button at most). header: replaces the whole default header.
// aside: right-panel content (RightPanelSection blocks); omit on pages without one. asideLabel: its aria-label.
// wide: no max-width (Calendar). flush: no page padding (full-bleed layouts). The TopBar carries the breadcrumb.
import { RightPanel } from './right-panel.jsx';
import { cx } from './ui.jsx';

export function PageTitle({ title, meta, subtitle, actions, class: cls, children }) {
  return (
    <header class={cx('page-header', cls)}>
      <div class="page-heading">
        <h1 class="page-title">
          {title}
          {meta != null && meta !== '' && <span class="page-title-meta">{meta}</span>}
        </h1>
        {subtitle && <p class="page-subtitle">{subtitle}</p>}
        {children}
      </div>
      {actions && <div class="page-actions">{actions}</div>}
    </header>
  );
}

export function Page({ title, meta, subtitle, actions, header, aside, asideLabel, wide, flush, class: cls, children }) {
  return (
    <div class={cx('page', wide && 'page-wide', flush && 'page-flush', cls)}>
      {header !== undefined ? header : title != null && <PageTitle title={title} meta={meta} subtitle={subtitle} actions={actions} />}
      {children}
      {aside && <RightPanel label={asideLabel}>{aside}</RightPanel>}
    </div>
  );
}
